<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" fixed app>
      <v-toolbar flat class="transparent">
        <v-list class="pa-0">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>Fichiers</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list dense>
        <v-divider></v-divider>
        <template v-for="item in items">
          <v-list-tile :key="item.name" @click="handleRoute(item)">
            <v-list-tile-avatar>
              <v-icon small class="material-icons-outlined">insert_drive_file</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-regular">{{ item.label }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="blue-grey darken-1"
      dark
      app
      fixed
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">
          <a
            href
            @click.prevent="$router.push('/')"
            style="text-decoration: none; color: white;"
          >TaBI</a>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <profile-menu />
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <router-view />
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import ProfileMenu from "./components/ProfileMenu";
import items from "./doc/files";

export default {
  components: {
    ProfileMenu,
  },
  data: () => ({
    dialog: false,
    drawer: null,
    items,
  }),
  methods: {
    handleRoute: function (item) {
      this.$router.push(item);
    },
  },
};
</script>

<style scoped>
router-link {
  text-decoration: none !important;
}
</style>
